var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 31L44 25.25V28C44 29.6569 42.6569 31 41 31H25Z",
    fill: "#FD6020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1916 12.1478C40.5853 12.1478 41.3518 12.7925 41.3518 14.0103C41.4215 14.9416 40.7943 15.7296 39.9581 15.8729L41.8396 18.5234H40.3762L38.7734 15.9445H38.6341V18.5234H37.4494V12.1478H39.1916ZM38.6341 15.0849H38.9825C39.749 15.0849 40.0975 14.7267 40.0975 14.082C40.0975 13.5089 39.749 13.1507 38.9825 13.1507H38.6341V15.0849ZM33.3379 18.5234H36.6829V17.4488H34.5226V15.7296H36.6132V14.655H34.5226V13.2223H36.6829V12.1478H33.3379V18.5234ZM29.8536 16.4459L28.2508 12.1478H26.9965L29.5749 18.6667H30.202L32.7804 12.1478H31.5261L29.8536 16.4459ZM15.7073 15.3714C15.7073 17.1623 17.101 18.6667 18.8432 18.6667C19.4007 18.6667 19.8885 18.5234 20.3763 18.3085V16.8758C20.0279 17.3056 19.5401 17.5921 18.9826 17.5921C17.8676 17.5921 16.9617 16.7325 16.9617 15.5863V15.4431C16.892 14.2969 17.7979 13.294 18.9129 13.2223C19.4704 13.2223 20.0279 13.5089 20.3763 13.9387V12.506C19.9582 12.2194 19.4007 12.1478 18.9129 12.1478C17.101 12.0045 15.7073 13.5089 15.7073 15.3714ZM13.547 14.5834C12.8502 14.2969 12.6411 14.1536 12.6411 13.7954C12.7108 13.3656 13.0592 13.0074 13.4773 13.0791C13.8258 13.0791 14.1742 13.294 14.4529 13.5805L15.0801 12.7209C14.5923 12.2911 13.9651 12.0045 13.338 12.0045C12.3624 11.9329 11.5261 12.7209 11.4564 13.7238V13.7954C11.4564 14.6551 11.8049 15.1565 12.9198 15.5147C13.1986 15.5863 13.4773 15.7296 13.7561 15.8729C13.9651 16.0161 14.1045 16.231 14.1045 16.5176C14.1045 17.019 13.6864 17.4489 13.2683 17.4489H13.1986C12.6411 17.4489 12.1533 17.0907 11.9442 16.5892L11.1777 17.3772C11.5958 18.1652 12.432 18.595 13.2683 18.595C14.3833 18.6667 15.2892 17.807 15.3589 16.6609V16.446C15.2892 15.5863 14.9407 15.1565 13.547 14.5834ZM9.50522 18.5234H10.6899V12.1478H9.50522V18.5234ZM4 12.1478H5.74216H6.09059C7.76306 12.2194 9.0871 13.6522 9.01741 15.3714C9.01741 16.3027 8.59929 17.1623 7.90243 17.807C7.27526 18.3085 6.50871 18.595 5.74216 18.5234H4V12.1478ZM5.5331 17.4488C6.09059 17.5205 6.71776 17.3056 7.13588 16.9474C7.554 16.5176 7.76306 15.9445 7.76306 15.2998C7.76306 14.7267 7.554 14.1536 7.13588 13.7238C6.71776 13.3656 6.09059 13.1507 5.5331 13.2223H5.18466V17.4488H5.5331Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9302 12C22.188 12 20.7246 13.4327 20.7246 15.2953C20.7246 17.0862 22.1183 18.5905 23.9302 18.6621C25.742 18.7338 27.1357 17.2294 27.2054 15.3669C27.1357 13.5044 25.742 12 23.9302 12V12Z",
    fill: "#FD6020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaDiscover);
export default __webpack_public_path__ + "static/media/aa-discover.837cee5d7e07b7b1865eec7ffd3ef74a.svg";
export { ForwardRef as ReactComponent };